import React from 'react';
import { Stack } from '@mui/material';
import { FieldValues, Path, Control } from 'react-hook-form';
import { CurrencyInputField, InputField } from 'components/form';
import { FACT_NAMES_NUMERIC } from '@trnsact/business-criteria';

interface Props<FormValues extends FieldValues = FieldValues> {
  namePrefix: Path<FormValues>;
  control: Control<FormValues>;
  type: FACT_NAMES_NUMERIC;
}

export const NumberFieldsByRule = <FormValues extends FieldValues = FieldValues>({
  namePrefix,
  type,
  control,
}: Props<FormValues>) => {
  const currencyInputs = [FACT_NAMES_NUMERIC.DOWN_PAYMENT, FACT_NAMES_NUMERIC.DEAL_SIZE];

  return (
    <Stack direction="row" gap="0.5rem" width="100%">
      {currencyInputs.includes(type) ? (
        <>
          <CurrencyInputField
            control={control}
            label="Min value"
            name={`${namePrefix}.number.min` as Path<FormValues>}
            textFieldProps={{ size: 'small', fullWidth: true, variant: 'outlined' }}
          />

          <CurrencyInputField
            label="Max value"
            control={control}
            name={`${namePrefix}.number.max` as Path<FormValues>}
            textFieldProps={{ size: 'small', fullWidth: true, variant: 'outlined' }}
          />
        </>
      ) : (
        <>
          <InputField
            label="Min value"
            control={control}
            name={`${namePrefix}.number.min` as Path<FormValues>}
            inputProps={{ type: 'number', variant: 'outlined' }}
          />

          <InputField
            label="Max value"
            control={control}
            name={`${namePrefix}.number.max` as Path<FormValues>}
            inputProps={{ type: 'number', variant: 'outlined' }}
          />
        </>
      )}
    </Stack>
  );
};
